import { FC, useMemo } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import selectedTypeState from "../../../recoil/SelectedType";
import engineState from "../../../recoil/SelectedEngine";
import { TEXT_MODELS, IMAGE_MODELS } from "../../../constants/models";

const EngineSelector: FC = () => {
  const selectedType = useRecoilValue(selectedTypeState);
  const [selectedEngine, setSelectedEngine] = useRecoilState(engineState);

  const options = useMemo(() => {
    if (selectedType === 'text' || selectedType === 'twitter') {
      return TEXT_MODELS;
    }
    return IMAGE_MODELS;
  
  }, [selectedType])
  return (
    <div className="mt-8 flex flex-col animate-openmodelselector delay-700">
      <p className="mb-4 font-bold text-xs text-base">Model / Engine</p>
      <select
        className="rounded-lg border-2 border-gray-300 p-2 text-xs"
        value={selectedType === 'text' || selectedType === 'twitter' ? selectedEngine.text : selectedEngine.image}
        onChange={(e) => {
          setSelectedEngine((prevState) => ({
            ...prevState,
            [selectedType]: e.target.value,
          }));
        }}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>{option.name}</option>
        ))}
      </select>
    </div>
  )
}

export default EngineSelector;